<div class="pallet-infos">
  <h1>Pallet:</h1>
  <app-info-oc-or-nfe label="Tag RFID" [value]="reportData.crate.tagRfid"></app-info-oc-or-nfe>
  <app-info-oc-or-nfe label="Posição esperada" [value]="toExcelFormat(reportData.crate.x, reportData.crate.y)"></app-info-oc-or-nfe>
  <app-info-oc-or-nfe label="Posição encontrada" [value]="foundPosition || '---' "></app-info-oc-or-nfe>
  <app-info-oc-or-nfe label="Altura esperada" [value]="reportData.crate.z + 'cm'"></app-info-oc-or-nfe>
  <app-info-oc-or-nfe label="Altura encontrada" [value]="foundHeight + 'cm'"></app-info-oc-or-nfe>
  <app-info-oc-or-nfe label="Status" [value]="crateState"></app-info-oc-or-nfe>
</div>